/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker, NumberFilterInput } from 'components/filters';
import {} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function CopackAgreementFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.startDate === 'undefined' && (
          <FormGroup>
            <Label>Startdatum</Label>
            <DateRangePicker
              name="startDate"
              value={_.get(resolvedQuery, 'startDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.articleFilter === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.serviceAgreement === 'undefined' && (
          <FormGroup>
            <Label>Serviceavtal</Label>
            <Select
              type="string"
              instanceId="select-serviceAgreement"
              name="serviceAgreement"
              value={_.get(resolvedQuery, 'serviceAgreement')}
              onChange={handleChange}
              options={[
                {
                  label:
                    'v2.5 - minimum serviceavgift  - Använder order och reklamationer',
                  value: 'v2.5',
                },
                { label: 'v3', value: 'v3' },
                {
                  label: 'Flaivy äger alla produkterna pã denna organisation',
                  value: 'articlesOwnedByFlaivy',
                },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.supplierCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på leverantörsorder(%)</Label>
            <NumberFilterInput
              name="supplierCommission"
              value={_.get(resolvedQuery, 'supplierCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.customerCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på weborder(%)</Label>
            <NumberFilterInput
              name="customerCommission"
              value={_.get(resolvedQuery, 'customerCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.salesCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på internorder (%)</Label>
            <NumberFilterInput
              name="salesCommission"
              value={_.get(resolvedQuery, 'salesCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.environmentFee === 'undefined' && (
          <FormGroup>
            <Label>Miljöavgift</Label>
            <NumberFilterInput
              name="environmentFee"
              value={_.get(resolvedQuery, 'environmentFee')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.purchaseOrderPriceExacta === 'undefined' && (
          <FormGroup>
            <Label>Kostnad inleverans Exacta (per artikel per pall)</Label>
            <NumberFilterInput
              name="purchaseOrderPriceExacta"
              value={_.get(resolvedQuery, 'purchaseOrderPriceExacta')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.purchaseOrderPriceVinden === 'undefined' && (
          <FormGroup>
            <Label>Kostnad inleverans Vinden (per artikel per pall)</Label>
            <NumberFilterInput
              name="purchaseOrderPriceVinden"
              value={_.get(resolvedQuery, 'purchaseOrderPriceVinden')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.monthlyBaseFee === 'undefined' && (
          <FormGroup>
            <Label>Basavgift per månad</Label>
            <NumberFilterInput
              name="monthlyBaseFee"
              value={_.get(resolvedQuery, 'monthlyBaseFee')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.monthlyExcessFee === 'undefined' && (
          <FormGroup>
            <Label>Månadsavgift per extra 10 artiklar</Label>
            <NumberFilterInput
              name="monthlyExcessFee"
              value={_.get(resolvedQuery, 'monthlyExcessFee')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.thresholdForEnvironmentFee === 'undefined' && (
          <FormGroup>
            <Label>Gränsvärde för miljöavgift</Label>
            <NumberFilterInput
              name="thresholdForEnvironmentFee"
              value={_.get(resolvedQuery, 'thresholdForEnvironmentFee')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.systembolagetCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på systembolag order (%)</Label>
            <NumberFilterInput
              name="systembolagetCommission"
              value={_.get(resolvedQuery, 'systembolagetCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.stockfillerCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på stockfiller order (%)</Label>
            <NumberFilterInput
              name="stockfillerCommission"
              value={_.get(resolvedQuery, 'stockfillerCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.whiteLabelCommission === 'undefined' && (
          <FormGroup>
            <Label>Marginal på order från egen webshop (%)</Label>
            <NumberFilterInput
              name="whiteLabelCommission"
              value={_.get(resolvedQuery, 'whiteLabelCommission')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.threasholdForDiscountedSupplierCommission ===
          'undefined' && (
          <FormGroup>
            <Label>Gränsvärde för storköp (exklusive pant och moms)</Label>
            <NumberFilterInput
              name="threasholdForDiscountedSupplierCommission"
              value={_.get(
                resolvedQuery,
                'threasholdForDiscountedSupplierCommission',
              )}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.largeOrderDiscount === 'undefined' && (
          <FormGroup>
            <Label>
              Rabatt på leverantörs kommission vid storköp (procentenheter)
            </Label>
            <NumberFilterInput
              name="largeOrderDiscount"
              value={_.get(resolvedQuery, 'largeOrderDiscount')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.exactaFreightCostPerKg === 'undefined' && (
          <FormGroup>
            <Label>exacta: fraktkostnad per kg</Label>
            <NumberFilterInput
              name="exactaFreightCostPerKg"
              value={_.get(resolvedQuery, 'exactaFreightCostPerKg')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.exactaHandlingCostPerColli === 'undefined' && (
          <FormGroup>
            <Label>Hanteringskostnad per DFP för Systembolaget</Label>
            <NumberFilterInput
              name="exactaHandlingCostPerColli"
              value={_.get(resolvedQuery, 'exactaHandlingCostPerColli')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.vindenHandlingCostPerColli === 'undefined' && (
          <FormGroup>
            <Label>Hanteringskostnad per DFP från Webblager</Label>
            <NumberFilterInput
              name="vindenHandlingCostPerColli"
              value={_.get(resolvedQuery, 'vindenHandlingCostPerColli')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.freightDiscountPercentage === 'undefined' && (
          <FormGroup>
            <Label>Rabatterad distribution från Webblager (%)</Label>
            <NumberFilterInput
              name="freightDiscountPercentage"
              value={_.get(resolvedQuery, 'freightDiscountPercentage')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.taxWarehouseNumberAtVinden === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.prognosisOrderCount === 'undefined' && (
          <FormGroup>
            <Label>Prognos antal order per 12 månader</Label>
            <NumberFilterInput
              name="prognosisOrderCount"
              value={_.get(resolvedQuery, 'prognosisOrderCount')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.prognosisRevenue === 'undefined' && (
          <FormGroup>
            <Label>Prognos omsättning per 12 månader</Label>
            <NumberFilterInput
              name="prognosisRevenue"
              value={_.get(resolvedQuery, 'prognosisRevenue')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.email === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.customerNumberInFortnox === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.settlementPeriod === 'undefined' && (
          <FormGroup>
            <Label>Avräkningsperiod</Label>
            <Select
              type="string"
              instanceId="select-settlementPeriod"
              name="settlementPeriod"
              value={_.get(resolvedQuery, 'settlementPeriod')}
              onChange={handleChange}
              options={[
                { label: 'varje vecka', value: 'weekly' },
                { label: 'varje månad', value: 'monthly' },
                { label: 'hel och halv månad', value: 'fullAndHalfMonth' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.sendSettlementAutomatically === 'undefined' && (
          <FormGroup>
            <Label>Skicka avräkningar automatiskt</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'sendSettlementAutomatically') ===
                  undefined
                }
                onClick={() => {
                  handleChange('sendSettlementAutomatically', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'sendSettlementAutomatically') ===
                    true ||
                  _.get(resolvedQuery, 'sendSettlementAutomatically') === 'true'
                }
                onClick={() => {
                  handleChange('sendSettlementAutomatically', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'sendSettlementAutomatically') ===
                    false ||
                  _.get(resolvedQuery, 'sendSettlementAutomatically') ===
                    'false'
                }
                onClick={() => {
                  handleChange('sendSettlementAutomatically', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

CopackAgreementFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

CopackAgreementFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function CopackAgreementFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <CopackAgreementFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

CopackAgreementFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

CopackAgreementFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = {
  CopackAgreementFilterPanel,
  CopackAgreementFilterPanelModal,
};
